export const projectFeaturesConstants = {    END_CUSTOMER_SHIPMENT: 'END_CUSTOMER_SHIPMENT',};